import React from 'react';
import BreadcrumbDesigning from '../BreadcrumbDesigning';
import './style.scss';
import CardsServices from 'src/views/SoftwareEngineering/components/CardsServices';
import { cardDataInfoArchitecutreDesign } from 'src/shared/utils/string';
import FooterServices from 'src/views/SoftwareEngineering/components/FooterServices';
import Footer from 'src/components/footer';
import { Link } from 'react-router-dom';
const InfoArchitectureDesign = () => {
  return (
    <div className="page-container-info-architecture-design">
        <div className='image-container'>
          <div className='text-container drop-in-2'>
            <h1 className='heading'>Information Architecture Design</h1>
          </div>
            <Link to="/info-architecture-design" className='no-decoration'><BreadcrumbDesigning text={"Information Architecture Design"} /></Link>  
            <div className='red-bg-box'></div>
        </div>

        <CardsServices cardDataServices={cardDataInfoArchitecutreDesign} />
        <FooterServices />
        <Footer />
    </div>
  )
}

export default InfoArchitectureDesign